import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Study } from '@models';

export type ConfirmationResult = 'yes' | 'no' | 'cancel';

@Component({
  selector: 'modal-stage',
  templateUrl: './modal-stage.component.html',
  styleUrl: './modal-stage.component.scss'
})
export class ModalStageComponent implements AfterViewInit, OnChanges {
  @Input() open = false;
  @Input() title = 'Confirm';
  @Input() confirmLabel = 'View on my portfolio';
  @Input() cancelLabel = 'Close';
  @Input() message: string | null = null;
  @Input() tableData: MatTableDataSource<Study> | null = null;
  @Input() hasData = true;
  @Output() closed = new EventEmitter<ConfirmationResult>();

  // Computed property: show table if tableData is provided
  get showTable(): boolean {
    return this.tableData !== null;
  }

  @ViewChild('firstFocusable') firstFocusable?: ElementRef<HTMLButtonElement>;

  private router = inject(Router);

  ngAfterViewInit(): void {
    this.tryFocus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && changes['open'].currentValue && !changes['open'].firstChange) {
      this.tryFocus();
    }
  }

  onBackdrop(): void {
    this.closed.emit('cancel');
  }
  onCancel(): void {
    this.closed.emit('no');
  }
  onConfirm(): void {
    this.router.navigate(['/portfolio']);
    this.closed.emit('yes');
  }

  private tryFocus(): void {
    if (this.open && this.firstFocusable?.nativeElement) {
      requestAnimationFrame(() => this.firstFocusable!.nativeElement.focus());
    }
  }
}
